module.exports = __webpack_public_path__ + "poster2.jpg?7a9fef229b4cf9e467486aa03cc6217f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster2.jpg
// module id = 4
// module chunks = 0